import { isParseError } from "./errors";
// We'll only go up to first newline, max 10 characters
export const clip = (found) => {
    let text = found.length > 10
        ? found.slice(0, 10) + '...'
        : found;
    if (text.indexOf('\n') != -1) {
        text =
            text
                .slice(0, text.indexOf('\n') + 1)
                .replace('\n', '\\n');
    }
    return text;
};
let errorTextMem = {
    text: '',
    textLength: 0,
    newLineMatches: [],
    newLineMatchesReversed: [],
};
export const warnOrErrorAsPrettyError = (text, warnOrError) => {
    let location;
    let message;
    if (isParseError(warnOrError)) {
        location = warnOrError.rcBibParser.location;
        message = warnOrError.message;
    }
    else {
        location = warnOrError.location;
        message = warnOrError.message;
    }
    if (text !== errorTextMem.text) {
        errorTextMem.text = text;
        errorTextMem.textLength = text.length;
        errorTextMem.newLineMatches = [...text.matchAll(/\n/g)];
        errorTextMem.newLineMatchesReversed = errorTextMem.newLineMatches.reverse();
    }
    let startCtx = 0;
    let startCtxIndex = 0;
    for (let index = 0; index < errorTextMem.newLineMatchesReversed.length; index++) {
        const match = errorTextMem.newLineMatchesReversed[index];
        if (match.index && (match.index < location)) {
            startCtxIndex = index;
            startCtx = match.index;
            break;
        }
    }
    const preCtx = text.slice(startCtx, location);
    let line = errorTextMem.newLineMatchesReversed.length - startCtxIndex;
    let postCtx = text.slice(location, location + 10);
    if (postCtx.length) {
        const match = postCtx.match(/\n/);
        if ((match === null || match === void 0 ? void 0 : match.index) != null) {
            postCtx = postCtx.slice(0, match.index);
        }
    }
    const ctx = `${preCtx}${postCtx}
${[...Array(location - startCtx)].join(' ')}^`;
    return {
        line,
        message,
        ctx,
    };
};
export const prettyErrors = (text, warnsOrErrors) => {
    const issues = warnsOrErrors
        .map(warnOrError => warnOrErrorAsPrettyError(text, warnOrError));
    return issues;
};
